<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h3 class="heading">One Step Closer! Tell Us About Your Work</h3>
            </div>
        </div>
        <div class="row justify-content-center mt-4">
            <div class="col-11 white_box p-4">
                <p class="sub-heading">Choose the option that best describes you.</p>
                <form [formGroup]="model" novalidate autocomplete="off" (ngSubmit)="submit()">
                    <div class="row justify-content-center">
                        <div class="col-sm-10 col-12">
                            <div class="form-group">
                                <div class="d-flex alogn-items-center justify-content-between gap-2 w-100">
                                    <div class="card shadow" *ngFor="let professionType of professionTypes"
                                        [ngClass]="selectedProfession && professionType.type === selectedProfession.type ? 'active' : ''"
                                        (click)="onProfessionSelect(professionType)">
                                        <div class="card-body">
                                            <div class="row h-100">
                                                <div
                                                    class="col-md-6 col-12 d-flex justify-content-center align-items-center">
                                                    <p class="profession_type">{{ professionType.type }}</p>
                                                </div>
                                                <div class="col-md-6 col-12 profession_icon">
                                                    <img [src]="professionType.icon" alt="profession_icon"
                                                        class="img-fluid">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <select formControlName="professionType" class="form-select"
                                    (change)="onProfessionTypeChange()">
                                    <option value="">Profession Type</option>
                                    <option *ngFor="let professionType of professionTypes"
                                        [value]="professionType.type">
                                        {{ professionType.type }}
                                    </option>
                                </select>
                                <div class="error"
                                    *ngIf="model.get('professionType')?.invalid && model.get('professionType')?.touched"
                                    @fadeInOut>
                                    Profession Type is mandatory
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div>
                        <h3 class="note" *ngIf="selectedProfession && isSalarized">Faster approvals with minimal
                            documents</h3>
                        <h3 class="note" *ngIf="selectedProfession && isSelfEmployed">Flexible EMI options to manage
                            cashflows better</h3>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-sm-10 col-12">
                            <ng-container *ngIf="selectedProfession && isSelfEmployed">
                                <div class="row mt-5" @fadeInOut>
                                    <div class="col-11 col-sm-6">
                                        <div class="form-group">
                                            <label class="control-label">Company Name</label>
                                            <input formControlName="companyName" class="form-control"
                                                placeholder="Enter Company Name" />
                                            <span
                                                *ngIf="model.get('companyName')?.invalid && model.get('companyName')?.touched"
                                                class="alert alert-danger mt-2">
                                                Company Name is mandatory
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-11 col-sm-6">
                                        <div class="form-group">
                                            <label class="control-label">Company Type</label>
                                            <select formControlName="companyType" class="form-select"
                                                style="margin-top: .3rem;">
                                                <option value="">Select Company Type</option>
                                                <option *ngFor="let companyType of companyTypes">
                                                    {{ companyType }}
                                                </option>
                                            </select>
                                            <span
                                                *ngIf="model.get('companyType')?.invalid && model.get('companyType')?.touched"
                                                class="alert alert-danger mt-2">
                                                Company Type is mandatory
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="row"
                                *ngIf="model.get('companyType').value.length > 0 && selectedProfession && isSelfEmployed"
                                @fadeInOut>
                                <div class="col-12 col-lg-12 col-md-12; position: relative;">
                                    <div class="form-group">
                                        <label class="control-label" *ngIf="!model.get('skipGst')?.value">GST</label>
                                        <div class="gstvisible" [class.moved]="isMoved">
                                            <input formControlName="gst" class="form-control"
                                                placeholder="Provide your GST Number"
                                                pattern="^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
                                                (blur)="comparePan()"
                                                [attr.disabled]="((model.get('skipGst')?.value) || gstInactive) ? true : null"
                                                [class.disabledCss]="(model.get('skipGst')?.value) || gstInactive" />
                                            <div *ngIf="model.get('gst').invalid && model.get('gst').touched"
                                                class="error">Invalid GST format
                                            </div>
                                        </div>
                                        <div class="animated-div" [class.moved]="isMoved">
                                            <input type="checkbox" formControlName="skipGst" id="skipGst"
                                                class="form-check-input" [attr.disabled]="gstInactive"
                                                style="margin-top: 6px;">
                                            <label class="control-label'" for="skipGst"
                                                style="font-family: 'Roboto', sans-serif; font-size: 0.8rem; color: #044b5f; font-weight: 600; margin-bottom: 0px !important;">
                                                No GST Registration
                                            </label>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-12 col-md-12 col-lg-12" *ngIf="model.get('skipGst')?.value" @fadeInOut>
                                    <div class="form-group">
                                        <div class="mt-3">
                                            <label class="control-label">Business Proof Document </label><span
                                                style="font-family: 'Roboto', sans-serif;font-size: 0.8rem;/* color: #044b5f; *//* font-weight: 600; */margin-bottom: 0px !important;">
                                                (Udyog Aadhaar)<span style="color:red">*</span></span>
                                            <input #businessdoc class="form-control" type="file"
                                                accept=".pdf, .jpg, .jpeg, .png" id="businessProof"
                                                (change)="onFileSelected($event, 'business')" text="Choose File"
                                                style="margin-top: .8rem" />
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-md-12 col-lg-12" *ngIf="showITR" @fadeInOut>
                                    <div class="form-group">
                                        <div class="mt-3">
                                            <label class="control-label">Income Proof Document </label><span
                                                style="font-family: 'Roboto', sans-serif;font-size: 0.8rem;/* color: #044b5f; *//* font-weight: 600; */margin-bottom: 0px !important;">
                                                (ITR)<span style="color:red">*</span></span>
                                            <input #incomedoc class="form-control" type="file" accept=".pdf"
                                                id="businessProof" (change)="onFileSelected($event, 'income')"
                                                text="Choose File" style="margin-top: .8rem" />
                                        </div>
                                    </div>
                                </div>

                                <!-- Upload Preview - hide as requirement changed -->
                                <!-- <div class="row image-upload-wrap ng-star-inserted" style="margin-top: 0.9rem;padding-block: 1rem;margin-inline: 0.5rem;width: 97%;" *ngIf="model.get('skipGst')?.value && uploader.queue.length > 0">
                  <div class="col-11">
                    <div class="file-list-preview">
                      <div class="file-list">
                        <ul style="padding-left: 1rem;">
                          <li *ngFor="let file of uploader.queue">
                            <span><p (click)="fileSelected(file)" style="cursor: pointer;" style="font-family: 'Roboto', sans-serif; font-size: 0.8rem; color: #044b5f; font-weight: 600; margin-bottom: 0px !important; text-align: start;">{{ file.file.name }}</p></span>
                            <button (click)="removeFile(file)" style="margin-right: 2rem;"><i class="fas fa-trash-alt"></i></button>
                          </li>
                        </ul>
                      </div>
                      <div class="file-preview">
                        <ng-container *ngIf="selectedFile">
                          <img *ngIf="selectedFile.isImage" [src]="selectedFile.previewUrl" alt="File Preview" class="preview-img" />
                          <object *ngIf="!selectedFile.isImage" [data]="selectedFile.previewUrl" class="preview-object" type="application/pdf"></object>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div> -->

                            </div>
                            <!-- <div class="row"  *ngIf="isSelfEmployed">
                <div class="col-11 col-sm-6">
                    <div class="form-group">
                        <div class="form-check">
                          <input type="checkbox" formControlName="skipGst" id="skipGst" class="form-check-input" [attr.disabled] = "gstInactive" />
                          <label class="form-check-label" for="skipGst">Skip GST</label>
                        </div>
                      </div>
                </div>
              </div> -->
                            <!-- <div class="row justify-content-center" *ngIf="model.get('skipGst')?.value">
                <div class="col-12">
                  <div class="file-upload">
                    <div class="image-upload-wrap">
                      <button type="button" class="remove-btn" (click)="removeFile()">
                        <i class="fas fa-trash-alt"></i>
                      </button>
                      <div #filedrop ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (click)="file.click()" (onFileSelected)="updatePreview()" (fileOver)="fileOverBase($event)" [uploader]="uploader" class="upload-drop-zone">
                        <div class="drag-text" *ngIf="uploader.queue.length == 0">
                          <h3><i class="fas fa-upload"></i><br />
                            Drag & drop or select file<br />
                            <div class="choose_file"> Choose file </div>
                          </h3>
                        </div>
                        <object *ngIf="image" id="myimage" width="100%" [data]='image' class="img_preview"></object>
                        <input #file style="display: none;" type="file" (onFileSelected)="updatePreview()" ng2FileSelect [uploader]="uploader" multiple />
                      </div>
                    </div>
                  </div>
                  <p class="uploaddocfooter text-success mt-0"> Please upload the documents only in PDF format</p>
                </div>
              </div> -->
                            <ng-container
                                *ngIf="!model.get('skipGst')?.value && model.get('companyType').value.length > 0 && model.get('companyType').value !== 'Proprietorship' && isSelfEmployed">
                                <div class="form-group">
                                    <label class="control-label">Company PAN</label>
                                    <input formControlName="companyPan" class="form-control"
                                        placeholder="Please enter a Company Pan" [required]="true" maxlength="10" />
                                    <div *ngIf="model.get('companyPan').invalid && model.get('companyPan').touched"
                                        class="error">Invalid PAN Number.
                                    </div>
                                </div>
                            </ng-container>
                            <label *ngIf="isBankStatementUpload">
                                <p>{{bankStatementRequired}}</p>
                            </label>
                        </div>
                    </div>
                    <div class="row justify-content-center mb-2 mt-2 buttonDiv">
                        <div class="col-6 text-center">
                            <div *ngIf="selectedProfession && !isSalarized" @fadeInOut>
                                <button type="submit" class="btn btn-warning" style="width: max-content;"
                                    [attr.disabled]="(((showITR ? ((!filesData[1].professionIdtype || filesData[1].professionIdtype === '' ) || (!filesData[0].professionIdtype || filesData[0].professionIdtype === '' )) : !filesData[0].professionIdtype || filesData[0].professionIdtype === '') && model.get('skipGst')?.value  ) || (!model.get('skipGst')?.value && (!companyTypes.includes(model.get('companyType')?.value) || !model.get('gst')?.value || model.get('gst').invalid))) ? true : null">
                                    Personalize My Credit Line
                                </button>
                            </div>
                            <div *ngIf="selectedProfession && isSalarized">
                                <button type="submit" class="btn btn-warning">Personalize My Credit
                                    Line</button>
                            </div>
                        </div>
                    </div>
                </form>
                <div>
                    <p class="text-center">This helps us personalize the best travel credit line for you. It takes just
                        a few seconds!​</p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-5 col-11">
        <app-assist-left></app-assist-left>
    </div>
</div>
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>